import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { AudioOutlined, StopOutlined } from '@ant-design/icons';
import styles from './TranscriptionButton.module.css';

const TranscriptionButton = ({ onStart, onStop, isTranscribing, isStarting, callActive }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        if (isStarting) return;
        if (isTranscribing) {
            onStop?.();
        } else if (callActive) {
            onStart?.();
        }
    };

    // If call is not active and not transcribing, render nothing
    if (!callActive && !isTranscribing) return null;

    return (
        <div className={styles.transcriptionButtonContainer}>
            <Tooltip 
                title={isTranscribing ? 'Stop Recording Transcript' : 'Start Recording Transcript'} 
                placement="left"
            >
                <Button
                    type="primary"
                    danger={isTranscribing}
                    size="large"
                    icon={isTranscribing ? <StopOutlined /> : <AudioOutlined />}
                    className={`${styles.transcriptionButton} ${isTranscribing ? styles.recording : styles.idle}`}
                    onClick={handleClick}
                    disabled={isStarting || (!isTranscribing && !callActive)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {isStarting ? 'Starting...' : isTranscribing ? 'Stop Transcript' : 'Start Transcript'}
                </Button>

                {(isTranscribing && !callActive) && (
                    <div className={styles.transcriptionHelperText}>
                        You must stop the transcript before starting a new call.
                    </div>
                )}
            </Tooltip>

            {isTranscribing && <div className={styles.pulseRing}></div>}
        </div>
    );
};

export default TranscriptionButton;